export default "__VITE_ASSET__CtpAt0kz__"